export default "__VITE_ASSET__0dc1607d__"